import { fetch } from '@/common/request';
import { NODE_TYPE } from '@/pages/dashboard/workflow/constants';

export interface ProcessListVo {
  id: number;
  name: string;
  description?: string;
  createTime: string;
  updateTime: string;
  welcome?: string;
  definition?: string;
}

// 字段定义
export interface Field {
  fieldName: string;
  fieldType: string;
  required: boolean;
  description: string;
  optionSource: string;
  optionUrl: string;
  displayOnly: boolean;
  multiSelect: boolean;
  acceptVariable: boolean;
  sort: number;
  placeHolder: string;
}

// 变量定义
export interface Variable {
  id: number;
  nodeTypeId: number;
  variableName: string;
  variableType: string;
  required: boolean;
  description: string;
  defaultValue: string;
  schema: string;
  displayOnly: boolean;
  type: number;
  sort: number;
}

export interface ProcessNodeVo {
  id: number;
  name: string;
  description?: string;
  icon?: string;
  fields: Field[];
  variables: Variable[];
}

export interface ProcessNode {
  nodeId?: string;
  nodeTypeId: NODE_TYPE;
  config?: Record<string, any>;
  // 条件分支（仅 CONDITION 节点需要）
  branches?: {
    expression: string;
    priority: number;
    fromNodeId: string;
    toNodeId: string;
  };
}

export interface ProcessTransition {
  fromNodeId: string;
  toNodeId: string;
}

export interface UpdateProcess {
  id?: string;
  name?: string;
  description?: string;
  definition: string;
  welcome?: string;
  nodes?: ProcessNode[];
  transitions?: ProcessTransition[];
}

// 流程定义列表
export function getProcessList(): Promise<ProcessListVo[]> {
  return fetch(
    '/api/processDefinition/list',
    {
      method: 'POST',
    },
    true
  );
}
// 删除流程定义
export function deleteProcess(id: number): Promise<any> {
  return fetch(
    '/api/processDefinition/delete',
    {
      method: 'POST',
      body: JSON.stringify({ id }),
    },
    true
  );
}

// 节点元数据
export function getProcessNodeMetaData(): Promise<ProcessNodeVo[]> {
  return fetch(
    '/api/processNode/metadata',
    {
      method: 'POST',
    },
    true
  );
}
export function updateProcess(params: UpdateProcess): Promise<any> {
  return fetch(
    '/api/processDefinition/update',
    {
      method: 'POST',
      body: JSON.stringify(params),
    },
    true
  );
}

export function saveProcess(params: UpdateProcess): Promise<any> {
  return fetch(
    '/api/processDefinition/save',
    {
      method: 'POST',
      body: JSON.stringify(params),
    },
    true
  );
}

export function getProcessDetail(id: string): Promise<ProcessListVo> {
  return fetch(
    '/api/processDefinition/detail',
    {
      method: 'POST',
      body: JSON.stringify({ id }),
    },
    true
  );
}

export function copyProcess(params: { id: number; name: string }) {
  return fetch(
    '/api/processDefinition/copy',
    {
      method: 'POST',
      body: JSON.stringify(params),
    },
    true
  );
}
